import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';
import { ITableModel } from '../table/model/tableModel';
import { DecryptPipe } from '../../../auth/_services/encrypt-decrypt.pipe';
import { CookieService } from 'ngx-cookie-service';
import { Helpers } from '../../../helpers';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-change-tranporter-driver-history',
  templateUrl: './change-tranporter-driver-history.component.html',
  styleUrls: ['./change-tranporter-driver-history.component.scss']
})
export class ChangeTranporterDriverHistoryComponent implements OnInit, OnDestroy {

  static that: ChangeTranporterDriverHistoryComponent;
  @Input() BookingId: any;
  @Input() HistoryType: any;
  @Output() onCloseEvent = new EventEmitter<any>();
  changeHistoryArray: any = [];
  isShowChangeHistoryModal = false;
  totalCount: number = 0;
  noOfPages: number = 15;
  CompanyId: any;
  userId: any;
  reportHeader: any = [];

  isMobileView: any;

  constructor(
    private router: Router,
    private _appService: appService,
    private toastr: ToastrService,
    private decryptpipe: DecryptPipe,
    private cookieService: CookieService,
    private renderer: Renderer2,
    public activeModal: NgbActiveModal
  ) {
    ChangeTranporterDriverHistoryComponent.that = this;
  }

  tableDetails: ITableModel = {
    emptyDataMSg: "No Records Found",
    data: [],
    columnDetails: [],
    actionList: [],
    isColumnNameShow: true
  };

  ngOnInit() {
    const ChnageCompnayId = JSON.parse(localStorage.getItem("ChnageCompnayId"));
    this.CompanyId = ChnageCompnayId && ChnageCompnayId.Id;
    this.userId = this.decryptpipe.transform(JSON.parse(this.cookieService.get("UserId")));
    if (this.BookingId) {
      this.openChangeHistoryModal(this.BookingId);
    }
    this.renderer.addClass(document.body, 'modal-lg-override');
  }

  ngOnDestroy(): void {
    this.renderer.removeClass(document.body, 'modal-lg-override');
  }

  openChangeHistoryModal(Id, pageNo: number = 0, perPage: any = this.noOfPages,) {
    Helpers.setLoading(true);
    let obj: any = {};
    obj.BookingId = Id;
    obj.Start = (pageNo * perPage);
    obj.Length = perPage;
    obj.HistoryType = this.HistoryType;

    this._appService.Post("OrdersByVehicle", "GetNewBookingTransporterDriverHistory", obj).subscribe(
      (response) => {
        if (response.length) {
          this.totalCount = response[0].recordcount;
          //  this.isListApiCalled = true;

          let i = 0;
          response.forEach(function (value, prop, obj) {
            if (i == 0) {
              delete value["recordcount"]; // This removes the "Record Count" from each data entry
              delete value["Id"];
              ChangeTranporterDriverHistoryComponent.that.reportHeader = Object.getOwnPropertyNames(value);
            }
            i++;
          });

          this.tableDetails.columnDetails = [];
          for (const item of this.reportHeader) {
            var obj: any = {};
            obj.columnName = item;
            obj.dataFieldName = item;
            this.tableDetails.columnDetails.push(obj);
          }
        }
        this.assignTableFields(pageNo, perPage, response);
        Helpers.setLoading(false);
      },
      (err) => {
        Helpers.setLoading(false);
        this.toastr.error("Error in fetching data. Please try again.", "error");
      }
    );
  }

  closeChangeHistoryModal() {
    // this.activeModal.close();
    this.activeModal.close();
    // this.onCloseEvent.emit();
  }

  assignTableFields(pageNo, perPage, data) {
    this.tableDetails = {
      ...this.tableDetails, paginationDetails: {
        totalItems: this.totalCount,
        itemsPerPage: perPage,
        currentPage: pageNo + 1
      },
      data: data
    }
  }

  onPageNumberChange(noOfPages: any) {
    localStorage.setItem('perPage', noOfPages);
    this.noOfPages = noOfPages
    this.openChangeHistoryModal(this.BookingId,0,noOfPages);
  }

  onPageChange(pageNo: number) {
    const storedPerPage = localStorage.getItem('perPage') || this.noOfPages;
    this.openChangeHistoryModal(this.BookingId,pageNo - 1,this.noOfPages);
  }
}
